import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import ShopColumnThreeMain from "./ShopColumnThreeMain";
import Footer from "../../components/Footer";
import ProductModal from "../../components/Modal/ProductModal";

const ShopColumnThree = () => {
  return (
    <>
      <ProductModal />

      <HeaderFour />

      <ShopColumnThreeMain />

      <Footer />
    </>
  );
};

export default ShopColumnThree;
